import { IDictionary, OddMarketValueTypes } from '../types';

export const MarketValueTypes: IDictionary<OddMarketValueTypes> = {
  FRACTIONAL: 'fractional',
  DECIMAL: 'decimal',
  MONEYLINE: 'moneyline',
};
